export default __webpack_public_path__ + "016aa78d0157ba02cabac18f59f0b5e6.svg";